exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\r\n  height: 40px;\r\n  background-color:#42B0D5;\r\n  z-index: 1000;\r\n  position: fixed;\r\n  width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/header/header.component.css
// module id = ../../../../../src/app/layout/home/header/header.component.css
// module chunks = main